'use client'

import { RotateCcw } from 'lucide-react'
import './service-visuals.css'

// Shared pieces for the interactive demos on the service and industry pages
// (the "What is it" section, replacing the old code-editor cards). Each demo
// acts out what the paragraph beside it describes, in the visitor's terms.

/**
 * The demo card: title with a live dot, optional tabs and replay, then the
 * body. Sits on a slight 3D angle that straightens while the visitor uses it.
 */
export function DemoFrame({ label, title, tabs, activeTab, onTab, onReplay, className = '', children, frameRef }) {
  return (
    <div className="svd-stage" ref={frameRef}>
      <div className={`svd ${className}`} role="group" aria-label={label || title}>
        <div className="svd-head">
          <span className="svd-title"><span className="svd-live" aria-hidden="true" />{title}</span>
          {onReplay ? (
            <button type="button" className="svd-replay" onClick={onReplay}>
              <RotateCcw size={13} aria-hidden="true" /> Replay
            </button>
          ) : null}
        </div>
        {tabs ? (
          <div className="svd-tabs" role="tablist" aria-label={`${title}: choose a view`}>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.key}
                className={`svd-tab${activeTab === tab.key ? ' is-on' : ''}${tab.tone ? ` is-${tab.tone}` : ''}`}
                onClick={() => onTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        ) : null}
        <div className="svd-body">{children}</div>
      </div>
    </div>
  )
}

/** Three bouncing dots, shown while the other side is "typing". */
export function TypingDots() {
  return (
    <span className="svd-typing" aria-hidden="true">
      <i /><i /><i />
    </span>
  )
}
